export default __webpack_public_path__ + "static/media/重疾险.cb58462d.jpg";